import classes from './Game.module.scss'
import { useRef, forwardRef, useImperativeHandle } from 'react';
import { Wheel } from './components/Wheel';



const Game = forwardRef(function Game({ onAnswer }, ref) {
  const wheelRef = useRef({});
  const gameRef = useRef();

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      await wheelRef.current.animateEntry()
    },
    // animateFail: async () => {
    //   console.log("animación de fallo")
    // }
  }));


  return (
    <div className={classes.game} ref={gameRef}>
      <Wheel
        onAnswer={onAnswer}
        gameRef={gameRef}
        ref={wheelRef}
      />
    </div>
  )
})

export default Game